import React, {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

//

const Text = props => {
  const history = useHistory();

  const onClick = useCallback(
    e => {
      const anchor = e.target.closest && e.target.closest('a');
      if (!anchor) return;
      if (e.defaultPrevented) return;
      if (anchor.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch {
        return;
      }
      if (url.origin !== window.location.origin) return;

      if (/\/tag\/[^/]+\/?$/.test(url.pathname)) {
        e.preventDefault();
        const pathname = url.pathname.endsWith('/') ? url.pathname : url.pathname + '/';
        history.push(pathname + url.search + url.hash);
      }
    },
    [history]
  );

  return <div className="w-full h-full overflow-y-auto scroll-y-nobar" onClick={onClick} dangerouslySetInnerHTML={{__html: props.datas.text}} />;
};

export default Text;
